module.exports = __webpack_public_path__ + "static/media/mod_risev2_5.bb1328da.jpg";